import React from 'react';
import { FormGroup, Label, Input} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import SelectBranchOrder from '../Form/SelectBranchOrder';
import SelectUserOrder from '../Form/SelectUserOrder';
import CustomLoader from 'Component/Common/CustomLoader';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { setSetupOrder } from 'Services/Features/Order/orderSlice';

const AddOrderOfflineForm = () => {
    const dispatch = useDispatch();
    const data = useSelector(state => state.order.setupOrder)
    // console.log (data, 'data');
    const startUpload = useSelector(state => state.order.loading);

    const handleChanges = (name, value) => {
        // Handle perubahan jam mulai
        if (name === 'schedule_hour_start') {
            const updates = { [name]: value };
            
            // Jika jam selesai sudah ada dan jam mulai baru lebih besar, reset jam selesai
            if (data.schedule_hour_end && value >= data.schedule_hour_end) {
                updates.schedule_hour_end = '';
            }
            
            dispatch(setSetupOrder(updates));
        }
        // Handle perubahan jam selesai
        else if (name === 'schedule_hour_end') {
            const updates = { [name]: value };
            
            // Jika jam mulai sudah ada dan jam selesai baru lebih kecil, reset jam mulai
            if (data.schedule_hour_start && value <= data.schedule_hour_start) {
                updates.schedule_hour_start = '';
            }
            
            dispatch(setSetupOrder(updates));
        }
        // Handle field lainnya
        else {
            dispatch(setSetupOrder({ [name]: value }));
        }
    }

    return (
        <>
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <FormGroup className='mb-3'>
                    <Label for="validationName" style={{ fontWeight: 'bold' }}>Cabang :</Label>
                    <SelectBranchOrder/>
                </FormGroup>
                <FormGroup className='mb-3'>
                    <Label for="validationDescription" style={{ fontWeight: 'bold' }}>Pengguna :</Label>
                    <SelectUserOrder />
                </FormGroup>
                <FormGroup className='mb-3'>
                    <Label for="validationName" style={{ fontWeight: 'bold' }}>Tanggal :</Label>
                    <DatePicker
                        selected={data.schedule_date ? new Date(data.schedule_date) : null}
                        onChange={(date) => handleChanges("schedule_date", format(date, "yyyy-MM-dd"))}
                        dateFormat="yyyy-MM-dd"
                        timeCaption="Waktu"
                        className="form-control digits"
                        placeholderText="Pilih Tanggal"
                        minDate={new Date()}                    />
                </FormGroup>
                <FormGroup className='mb-3'>
                    <Label for="validationName" style={{ fontWeight: 'bold' }}>Jam Mulai :</Label>
                    <DatePicker
                        selected={data.schedule_hour_start ? new Date(`1970-01-01T${data.schedule_hour_start}`) : null}
                        onChange={(date) => handleChanges("schedule_hour_start", format(date, "HH:mm"))}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Open"
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        className="form-control digits"
                        placeholderText="Pilih Jam Buka"
                        minTime={new Date(new Date().setHours(0, 0, 0, 0))}
                        maxTime={data.schedule_hour_end ? new Date(`1970-01-01T${data.schedule_hour_end}`) : new Date(new Date().setHours(23, 45, 0, 0))}
                    />
                </FormGroup>
                <FormGroup className='mb-3'>
                    <Label for="validationName" style={{ fontWeight: 'bold' }}>Jam Selesai :</Label>
                    <DatePicker
                        selected={data.schedule_hour_end ? new Date(`1970-01-01T${data.schedule_hour_end}`) : null}
                        onChange={(date) => handleChanges("schedule_hour_end", format(date, "HH:mm"))}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Close"
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        className="form-control digits"
                        placeholderText="Pilih Jam Tutup"
                        minTime={data.schedule_hour_start ? new Date(`1970-01-01T${data.schedule_hour_start}`) : new Date(new Date().setHours(0, 0, 0, 0))}
                        maxTime={new Date(new Date().setHours(23, 45, 0, 0))}
                    />
                </FormGroup>
                <FormGroup className='mb-3'>
                    <Label for="validationName" style={{ fontWeight: 'bold' }}>Catatan CS :</Label>
                    <Input
                        className="form-control"
                        type="textarea"
                        name="cs_notes"
                        placeholder="Opsional catatan CS..."
                        value={data.cs_notes || ''}
                        onChange={(e) => handleChanges(e.target.name, e.target.value)}
                    />
                </FormGroup>
            </div>
        </>
    );
};

export default AddOrderOfflineForm;